// LocaleDateFormatter/de.ts
import type { Translations } from './translationsTypes';

const de: Translations = {
    Hour: 'HH',
    Min: 'mm',
    Day: 'dd',
    Month: 'MMMM',
    Extend: 'a',
    HourMin: 'HH:mm',
    HourMinSecond: 'HH:mm:ss',
    HourMinFull: 'HH:mm:ss ZZZZ',
    Trunc: 'd. MMM yyyy',
    Date: 'd. MMMM yyyy',
    Classic: 'dd.MM.yyyy',
    DateGlobal: 'dd.MM.yyyy',
    TimeSpecial: '{HOUR}:{MIN} uhr',
    UTC: 'ZZZZ',
    AdfDayMonth: '{DAY}. {MONTH}',
    AdfTimeDate: 'um {TIME} am {DATE}',
    AdfDateTime: 'am {DATE} um {TIME}',
    AdfTime: '{TIME} am {DATE}',
    AdfDate: '{DATE} um {TIME}',
};

export default de;
